import styled from 'styled-components';

export const Body = styled.div`
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
`;

export const Dialog = styled.div<{ $hideBoxShadow?: boolean }>`
  width: 370px;
  min-height: 250px;
  background-color: ${({ theme }) => theme.configs.tertiaryBox.bgColor};
  box-shadow: ${({ $hideBoxShadow, theme }) =>
    $hideBoxShadow
      ? 'none'
      : `0 0 10px 0 ${theme.configs.tertiaryBox.secondaryFontColor}`};
`;

export const Header = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  padding: 22px;
  text-align: center;
  position: relative;
  background-color: ${({ theme }) => theme.configs.mainBox.bgColor};
  color: ${({ theme }) => theme.configs.mainBox.fontColor};
  svg {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
  }
`;

export const Content = styled.div`
  width: 100%;
  padding: 20px;
`;
